import { LocationListContent } from "./LocationListContent";

export default LocationListContent;
